import { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import { ROUTES } from '@shared/config/routes';
import { Loader } from '@shared/ui';

const HomePage = lazy(() =>
  import('@pages/homePage').then((module) => ({ default: module.HomePage })),
);
const CategoryPage = lazy(() =>
  import('@pages/categoryPage').then((module) => ({ default: module.CategoryPage })),
);
const ExercisePage = lazy(() =>
  import('@pages/exercisePage').then((module) => ({ default: module.ExercisePage })),
);

export const AppRouter = () => (
  <Suspense fallback={<Loader />}>
    <Routes>
      <Route path={ROUTES.HOME} element={<HomePage />} />
      <Route path={ROUTES.CATEGORY} element={<CategoryPage />} />
      <Route path={ROUTES.EXERCISE} element={<ExercisePage />} />
    </Routes>
  </Suspense>
);
